import { Box, Text } from '@streamelements/frontend-ui';
import { createFileRoute } from '@tanstack/react-router';
import { providerIcons } from '../../components/ProviderIcon';
import { AllowedProvider, platformPrettyName } from '../../constants/common';

export const Route = createFileRoute('/auth/$provider/error')({
  component: ErrorPage,
});

function ErrorPage() {
  const { provider } = Route.useParams();
  const Icon = providerIcons[provider as AllowedProvider];

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Box css={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <Box as="img" src="/logo.png" css={{ width: '3.25rem' }} />
        <Box as="img" src="/cross-mark.png" css={{ width: '1.25rem' }} />
        <Icon size="xl" css={{ '&&': { fontSize: '2.5rem' } }}></Icon>
      </Box>
      <Text.Heading level={5} css={{ m: 0 }} weight="bold">
        Connection failed
      </Text.Heading>
      <Text.Body css={{ color: '$textPrimary70' }}>
        The connection to {platformPrettyName[provider as AllowedProvider]} was not successful. <br />
        If you have any ad-blockers, please disable them temporarily and try again.
      </Text.Body>
    </Box>
  );
}
